import * as Bixby from '$/core';

export interface VerifyCompanyState {
  isLoading: boolean;
  error?: string;
  success: boolean;
  tokenInvalid: boolean;
}

export const VERIFY_COMPANY_INPROGESS = 'VERIFY_COMPANY_INPROGESS';
export const VERIFY_COMPANY_SUCCESS = 'VERIFY_COMPANY_SUCCESS';
export const VERIFY_COMPANY_FAILURE = 'VERIFY_COMPANY_FAILURE';

interface VerifyCompanyRequestInProgress extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_COMPANY_INPROGESS;
}

interface VerifyCompanyRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_COMPANY_SUCCESS;
  payload: boolean;
}

interface VerifyCompanyRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof VERIFY_COMPANY_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type VerifyCompanyActionTypes =
  | VerifyCompanyRequestInProgress
  | VerifyCompanyRequestSuccess
  | VerifyCompanyRequestFailure;
